// @file Store module for wall delete dialog, which ensure that users do not accidentally delete padlets.
import { Id } from 'types'
import { Module } from 'vuex'

const generateCode = (): string =>
  Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0')

interface WallDeleteDialogState {
  wallId: Id | null
  wallTitle: string
  confirmationCode: string
  deleteActionName: string
  deleteActionPayload: object | null
}

type OpenDialogPayload = Omit<WallDeleteDialogState, 'confirmationCode'>

const defaultState = (): WallDeleteDialogState => ({
  wallId: null,
  wallTitle: '',
  confirmationCode: '',
  deleteActionName: '',
  deleteActionPayload: null,
})

const WallDeleteDialogModule: Module<WallDeleteDialogState, object> = {
  namespaced: true,
  state: defaultState,
  getters: {
    isDialogOpen(state): boolean {
      return !!state.wallId
    },
  },
  mutations: {
    OPEN_DIALOG(state, { wallId, wallTitle, deleteActionName, deleteActionPayload }: OpenDialogPayload): void {
      state.wallId = wallId
      state.wallTitle = wallTitle
      state.confirmationCode = generateCode()
      state.deleteActionName = deleteActionName
      state.deleteActionPayload = deleteActionPayload
    },
    CLOSE_DIALOG(state): void {
      Object.assign(state, defaultState())
    },
    REGENERATE_CONFIRMATION_CODE(state): void {
      state.confirmationCode = generateCode()
    },
  },
  actions: {
    confirmWallDeletion({ commit }, payload: OpenDialogPayload): void {
      commit('OPEN_DIALOG', payload)
    },
    closeDialog({ commit }): void {
      commit('CLOSE_DIALOG')
    },
    submitConfirmation({ commit, dispatch, state }, enteredCode): void {
      if (enteredCode === state.confirmationCode) {
        dispatch(state.deleteActionName, state.deleteActionPayload, { root: true })
        dispatch('closeDialog')
      } else {
        commit('REGENERATE_CONFIRMATION_CODE')
      }
    },
  },
}

export default WallDeleteDialogModule
export { WallDeleteDialogState }
